/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import * as API from "../../framework/API/api";
import { EditPageHeader } from '../../components/EditPageHeader';
import { DropDownList, MultiSelect } from '@progress/kendo-react-dropdowns';
import { useTranslation } from '../../locale/useTranslation';
import { ENTITYNAME, PLATFORMTYPE, TOAST_TYPES } from '../../framework/constant/constant';
import { utility } from '../../framework/utility/utilityProvider';
import moment from "moment";
import BossDialog from '../../components/BossDialog';
import ToastNotification from '../../components/ToastNotification';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { SyndicateRightEditForm } from './SyndicateRightEditForm';
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import { DateOnlyCell } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';
import EditRoundButton from '../../framework/forms/helpercomponents/buttons/EditRoundButton';

export const ContractTitleEditForm = (props) => {
    console.log(props.data)

    const blankDataItem = {
        ...props.data,
        IsExclusive: props.data?.IsExclusive ?? false,
        ExclusiveStartDate: (props.data?.IsExclusive ?? false) ? moment(new Date(props.data?.ExclusiveStartDate)).utc().format('YYYY-MM-DD') : '',
        ExclusiveEndDate: (props.data?.IsExclusive ?? false) ? moment(new Date(props.data?.ExclusiveEndDate)).utc().format('YYYY-MM-DD') ?? '' : '',
        PublishStartDate: moment(new Date(props.data?.PublishStartDate)).format('YYYY-MM-DD'),
        PublishEndDate: moment(new Date(props.data?.PublishEndDate)).format('YYYY-MM-DD'),
        Region: props.data.Region ?? [],
        MinGap: props.data.MinGap ?? 0,
        SyndicateRight: Array.isArray(props.data?.SyndicateRight) ? props.data.SyndicateRight : []
    }

    const [dataItem, setDataItem] = useState(blankDataItem)
    const [playTime, setPlayTime] = useState([]);
    const [channel, setChannel] = useState([]);
    const [region, setRegion] = useState([]);
    const [platform, setPlatform] = useState([]);
    const [currency, setCurrency] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [showSyndicateRightEditForm, setShowSyndicateRightEditForm] = useState(false);
    // const selectedIndexRef = useRef(null);
    // const editingSyndicateRightRef = useRef(false);
    const [editingIndex, setEditingIndex] = useState(null);

    const lang = useTranslation();

    useEffect(() => {
        loadcombo();
    }, []);

    useEffect(() => {
        if (Array.isArray(props.data?.SyndicateRight)) {
            setGridData(props.data.SyndicateRight);
        } else {
            setGridData([]);
        }
    }, [props.data]);

    const loadcombo = async () => {
        var playTimeRes = await API.getDataLookup(ENTITYNAME.PlayTime, { sort: { Description: 1 } });
        setPlayTime(playTimeRes.data);
        var channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        setChannel(channelRes.data);
        var region = await API.getDataLookup(ENTITYNAME.Region, { sort: { Description: 1 } });
        setRegion(region.data);
        var platform = await API.getDataLookup(ENTITYNAME.Platform, { sort: { Description: 1 } });
        setPlatform(platform.data);
        var currencyRes = await API.getDataLookup(ENTITYNAME.Currency, { sort: { Description: 1 } });
        setCurrency(currencyRes.data);
    }
    const onChange = (e) => {
        if (e.target.name == "IsUnlimited") {
            dataItem.Exhibitions = 0;
            dataItem.Repeats = 0;
            dataItem.PlayTimeNumber = 0;
            dataItem.PlayTime = {};
            setDataItem({ ...dataItem, IsUnlimited: !dataItem.IsUnlimited });
        }
        else if (e.target.name == "Archive") {
            setDataItem({ ...dataItem, [e.target.name]: !dataItem[e.target.name] });
        } else if (e.target.name == 'IsExclusive') {
            setDataItem({ ...dataItem, IsExclusive: !dataItem.IsExclusive, ExclusiveStartDate: '', ExclusiveEndDate: '' });
        } else if (e.target.name == 'TBA') {
            setDataItem({ ...dataItem, TBA: !dataItem.TBA });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }

    const isValid = () => {
        if (!utility.isValidDate(dataItem.PublishStartDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_start_date });
            return false;
        }
        if (!utility.isValidDate(dataItem.PublishEndDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.invalid_end_date });
            return false;
        }
        if (dataItem.PublishStartDate >= dataItem.PublishEndDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.end_date_should_be_greater_than_start_date_error_message });
            return false;
        }
        // for non-linear
        if (props.data?.PlatformType.SID == PLATFORMTYPE[1].SID && dataItem.Platform.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_platform_error_message });
            return false;
        }
        if (props.data?.PlatformType.SID == PLATFORMTYPE[1].SID && dataItem.Region.length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_region_error_message });
            return false;
        }
        // for linear
        if (props.data?.PlatformType.SID == PLATFORMTYPE[0].SID) {
            if (dataItem.Channel.length == 0) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_channel_error_message });
                return false;
            }
            if (dataItem.Region.length == 0) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_region_error_message });
                return false;
            }
            if (dataItem.Amount < 0) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.amount_should_be_negative_error_message });
                return false;
            }
            if (Object.keys(dataItem.Currency).length == 0) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_Currency_error_message });
                return false;
            }
            if (!dataItem.IsUnlimited && dataItem.Exhibitions < 1) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.exhibition_should_not_be_zero_error_message });
                return false;
            }
            if (!dataItem.IsUnlimited && dataItem.PlayTimeNumber < 1) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.play_time_number_should_not_be_zero_error_message });
                return false;
            }
            if (!dataItem.IsUnlimited && Object.keys(dataItem.PlayTime).length == 0) {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_play_time_error_message });
                return false;
            }
        }
        if (dataItem.IsExclusive && !utility.isValidDate(dataItem.ExclusiveStartDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_exclusive_start_date_error_message });
            return false;
        }
        if (dataItem.IsExclusive && !utility.isValidDate(dataItem.ExclusiveEndDate)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_exclusive_end_date_error_message });
            return false;
        }
        return true;
    }

    const onSave = () => {
        if (isValid()) {
            const data = {
                ...dataItem,
                Amount: dataItem.Amount == "" ? 0 : parseFloat(dataItem.Amount),
                Exhibitions: parseInt(dataItem.Exhibitions),
                Repeats: parseInt(dataItem.Repeats),
                PlayTimeNumber: parseInt(dataItem.PlayTimeNumber),
                PublishStartDate: (new Date(dataItem.PublishStartDate)).getTime(),
                PublishEndDate: (new Date(dataItem.PublishEndDate)).getTime(),
                ExclusiveStartDate: dataItem.IsExclusive ? (new Date(dataItem.ExclusiveStartDate)).getTime() : 0,
                ExclusiveEndDate: dataItem.IsExclusive ? (new Date(dataItem.ExclusiveEndDate)).getTime() : 0,
                SyndicateRight: gridData.length > 0 ? gridData : []
            }
            console.log(data);
            props.saveEditData(data);
            props.onCancel();
        }
    }

    const CommandCell = (cellProps) => {
        const index = cellProps.dataIndex;
        return (
            <td>
                <EditRoundButton onClick={() => onEditSyndicateRight(index)} />
                <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => onRemoveSyndicateRight(index), () => { })} />
            </td>
        );
    };
    const onEditSyndicateRight = (index) => {
        setEditingIndex(index);
        setShowSyndicateRightEditForm(true);
    };
    const onRemoveSyndicateRight = (index) => {
        setGridData(prev => prev.filter((_, i) => i !== index));
        ToastNotification({
            type: TOAST_TYPES.SUCCESS,
            title: lang.success_message_title,
            message: lang.delete_successfully_grid_data_success_toast_message
        });
    };

    const syndicateRightData = (data) => {
        if (!data) { return; }
        setGridData(prev => {
            const currentData = Array.isArray(prev) ? [...prev] : [];
            if (editingIndex !== null) {
                currentData[editingIndex] = { ...currentData[editingIndex], ...data };
                return currentData;
            }
            return [...currentData, data];
        });
        setEditingIndex(null);
        setShowSyndicateRightEditForm(false);
    };

    const onAddSyndicateRight = () => {
        selectedIndexRef.current = null;
        editingSyndicateRightRef.current = false;
        setShowSyndicateRightEditForm(true);
    };

    return (
        <>
            <BossDialog title={`${lang.edit_label} ${dataItem?.ContractTitle?.Title}`} onClose={props.onCancel} width={"800px"}>
                <div className="row">
                    <div className="col-12">
                        <EditPageHeader showTitle={false} onSubmit={onSave} onCancel={props.onCancel} />
                        <div className="row mt-2">
                            <div className='col-6'>
                                <label>{lang.title_label} *</label>
                                <input type="text" className="form-control form-control-sm" name="Title" value={dataItem.ContractTitle?.Title} disabled />
                            </div>
                            <div className='col-6'>
                                <label>{lang.asset_id_label} *</label>
                                <input type="text" className="form-control form-control-sm" name="AssetsID" value={dataItem.ContractTitle?.AssetId} disabled />
                            </div>
                        </div>
                        <div className="row mt-2">
                            <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="">{lang.start_date_label} *</label>
                                    <input type="date" className="form-control form-control-sm" name="PublishStartDate" value={dataItem.PublishStartDate} onChange={(e) => onChange(e)} />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="form-group">
                                    <label htmlFor="">{lang.end_Date_label} *</label>
                                    <input type="date" className="form-control form-control-sm" name="PublishEndDate" value={dataItem.PublishEndDate} onChange={(e) => onChange(e)} />
                                </div>
                            </div>
                        </div>
                        {props.data?.PlatformType.SID == PLATFORMTYPE[0].SID && <div className='row'>
                            <div className='col-6'>
                                <label>{lang.channel_label} *</label>
                                <MultiSelect
                                    style={{ backgroundColor: "white" }}
                                    data={channel}
                                    name="Channel"
                                    textField="FullChannelName"
                                    dataItemKey="_id"
                                    value={dataItem.Channel}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="col-6">
                                <label htmlFor="TabView">{lang.region_label} *</label><br />
                                <MultiSelect
                                    data={region}
                                    style={{ backgroundColor: "white" }}
                                    textField="Description"
                                    dataItemKey="_id"
                                    name="Region"
                                    value={dataItem.Region}
                                    onChange={onChange}
                                />
                            </div>
                        </div>}
                        {props.data?.PlatformType.SID == PLATFORMTYPE[0].SID && <div className='row mt-2 mb-2'>
                            <div className="col-3">
                                <label htmlFor="">{lang.amount_label} *</label>
                                <input type="number" className="form-control form-control-sm" name="Amount" value={dataItem.Amount} onChange={(e) => onChange(e)} min={0} />
                            </div>
                            <div className="col-3">
                                <label htmlFor="">{lang.revenue_share_label}</label>
                                <input type="number" className="form-control form-control-sm" name="RevShare" value={dataItem.RevShare} onChange={(e) => onChange(e)} min={0} />
                            </div>
                            <div className="col-3">
                                <label htmlFor="">{lang.currency_label} *</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={currency}
                                    name="Currency"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.Currency}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="col-3">
                                <div className="form-group">
                                    <label htmlFor="">{lang.minimum_gap_label} </label>
                                    <input type="Number" className="form-control form-control-sm" name="MinGap" value={dataItem.MinGap} onChange={onChange} min={0} required />
                                </div>
                            </div>
                        </div>}
                        {props.data?.PlatformType.SID == PLATFORMTYPE[1].SID && <div className='row mt-2'>
                            <div className='col-6'>
                                <label htmlFor="TabView">{lang.platform_label} *</label><br />
                                <MultiSelect
                                    style={{ backgroundColor: "white" }}
                                    data={platform}
                                    name="Platform"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.Platform}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="col-6">
                                <label htmlFor="TabView">{lang.region_label} *</label><br />
                                <MultiSelect
                                    data={region}
                                    style={{ backgroundColor: "white" }}
                                    textField="Description"
                                    dataItemKey="_id"
                                    name="Region"
                                    value={dataItem.Region}
                                    onChange={onChange}
                                />
                            </div>
                        </div>}
                        <div className="row mt-2">
                            {props.data?.PlatformType.SID == PLATFORMTYPE[0].SID ? <div className="col-6">
                                <input type={"checkbox"} name={"IsUnlimited"}
                                    onChange={(e) => onChange(e)}
                                    value={dataItem.IsUnlimited}
                                    checked={dataItem.IsUnlimited} />
                                <label className="ml-1">{lang.is_unlimited_label}</label>
                            </div> :
                                <div className="col-6">
                                    <input name="TBA" type="checkbox" value={dataItem.TBA} checked={dataItem.TBA} onClick={onChange} onChange={() => { }} />
                                    <label className='ml-1'>{lang.tba_label}</label>
                                </div>}
                            <div className='col-6'>
                                <input name="IsExclusive" type={"checkbox"} value={dataItem.IsExclusive} checked={dataItem.IsExclusive} onClick={onChange} onChange={() => { }} />
                                <label className='ml-1'>{lang.exclusive_label}</label>
                            </div>
                        </div>
                        <div className="row mt-2">
                            {props.data?.PlatformType.SID == PLATFORMTYPE[0].SID ?
                                <div className="col-6">
                                    {!dataItem.IsUnlimited && <div className="row">
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label htmlFor="">{lang.exhibition_label} *</label>
                                                <input type="Number" className="form-control form-control-sm" name="Exhibitions" value={dataItem.Exhibitions} onChange={onChange} min="0" required />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label htmlFor="">{lang.repeat_label} *</label>
                                                <input type="Number" className="form-control form-control-sm" name="Repeats" value={dataItem.Repeats} onChange={onChange} min="0" required />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label htmlFor="">{lang.play_time_number_label} *</label>
                                                <input type="Number" className="form-control form-control-sm" name="PlayTimeNumber" value={dataItem.PlayTimeNumber} onChange={onChange} min="0" required />
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label htmlFor="TabView">{lang.playTime_label} *</label>
                                                <DropDownList
                                                    style={{backgroundColor: "white"}}
                                                    data={playTime}
                                                    name="PlayTime"
                                                    textField="Description"
                                                    dataItemKey="_id"
                                                    value={dataItem.PlayTime}
                                                    onChange={onChange}
                                                />
                                            </div>
                                        </div>
                                    </div>}
                                </div> : <div className='col-6'></div>}
                            <div className="col-6">
                                {dataItem.IsExclusive && <div className="row mb-3">
                                    <div className="col-6">
                                        <label htmlFor="">{lang.start_date_label} *</label>
                                        <input type={'date'} name="ExclusiveStartDate" value={dataItem.ExclusiveStartDate} onChange={onChange} max={dataItem.ExclusiveEndDate} className="form-control-sm"
                                            style={{ width: '100%', backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', paddingLeft: '5px' }} label={lang.start_date_label}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <label htmlFor="">{lang.end_Date_label} *</label>
                                        <input type={'date'} name="ExclusiveEndDate" onChange={onChange} value={dataItem.ExclusiveEndDate} min={dataItem.ExclusiveStartDate} className="form-control-sm"
                                            style={{ width: '100%', backgroundColor: 'white', border: '1px solid lightgrey', borderRadius: '5px', paddingLeft: '5px' }} label={lang.end_Date_label}
                                        />
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-8">
                        <AddRoundButton style={{ marginBottom: '5px' }} onClick={() => { setEditingIndex(null); setShowSyndicateRightEditForm(true); }} title={lang.add_syndicatRight_button_tooltip} />
                    </div>
                    <div className="col-4">
                        <div className="pull-right">Syndicate Rights ({gridData?.length ?? 0})</div>
                    </div>
                </div>
                <Grid style={{ height: '30vh', marginTop: "2px",width: '100%'}} data={gridData} resizable={true} scrollable="scrollable" >
                    <GridColumn cell={CommandCell} width={"95px"} locked={true} />
                    <GridColumn field="Licensor.Name" title={lang.licensor_label} width="120px" />
                    <GridColumn field="BroadcastMedium.Description" title={lang.broadcast_medium_label} width="120px" />
                    <GridColumn field="Exhibitions" title={lang.exhibition_column} width="80px" />
                    <GridColumn field="StartDate" title={lang.start_date_label} cell={DateOnlyCell} width="100px" />
                    <GridColumn field="EndDate" title={lang.end_date_label} cell={DateOnlyCell} width="100px" />
                    <GridColumn field="ExclusiveStartDate" title={lang.exclusive_start_date_label} cell={DateOnlyCell} width="140px" />
                    <GridColumn field="ExclusiveEndDate" title={lang.exclusive_end_date_label} cell={DateOnlyCell} width="120px" />
                    <GridColumn field="BlackoutStartDate" title={lang.blackout_start_date_label} cell={DateOnlyCell} width="140px" />
                    <GridColumn field="BlackoutEndDate" title={lang.blackout_end_date_label} cell={DateOnlyCell} width="120px" />
                    <GridColumn field="Amount" title={lang.amount_column} width="60px" />
                    <GridColumn field="Currency.Description" title={lang.currency_column} width="80px" />                    
                    <GridColumn field="Repeats" title={lang.repeats_column} width="60px" />
                    <GridColumn field="PlayTimeNumber" title={lang.play_time_number_column} width="120px" />
                    <GridColumn field="PlayTime.Description" title={lang.playTime_column} width="120px" />
                </Grid>
            </BossDialog>
            {showSyndicateRightEditForm && (<SyndicateRightEditForm data={editingIndex !== null ? gridData[editingIndex] : null} onCancel={() => { setEditingIndex(null); setShowSyndicateRightEditForm(false); }} saveEditData={syndicateRightData} />)}
        </>
    )
}
